import React, { forwardRef } from 'react';
import { Input } from '../Input/index.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlInput = forwardRef((props, ref) => {
    const { layoutProps, inputProps } = extractLayoutProps(props);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement(Input, Object.assign({ ref: ref }, inputProps))));
});
//# sourceMappingURL=FormControlInput.js.map